module.exports = __webpack_public_path__ + "static/media/testimonial_img2.44fd972f.png";